import { useCallback } from 'react'

export function useAttachStorageFiles({ onSetFiles }) {
  const handleRemoveStorageFile = useCallback(
    fileId => {
      onSetFiles(val => val.filter(f => f.id !== fileId))
    },
    [onSetFiles]
  )

  const handleAddStorageFile = useCallback(
    acceptedFiles => {
      onSetFiles(acceptedFiles)
    },
    [onSetFiles]
  )

  return {
    handleAddStorageFile,
    handleRemoveStorageFile,
  }
}
